<template>
  <v-container>
  <div id="nonprint">
    <!-- <v-btn icon :to="{ path: '/mymachine', query: { id: this.machineid }}"> -->
    <v-btn icon @click="$router.back()">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <span class="display-1 px-3" ID="sample-card">マイ機器QRコードシート</span>
  </div>
  <v-row dense class="mt-5 mx-5" id="nonprint">
    <v-col cols="12" dense>
          <v-btn 
            small 
            rounded 
            color="amber" 
            @click="barcodePrint()"
            class="caption"
            >
            <v-icon class="mr-2">mdi-printer</v-icon>
            QRコードを印刷する
          </v-btn>
    </v-col>
  </v-row>
  <div class="mt-3">
    <v-card class="px-3 pb-5">
      <v-card-title class="font-weight-bold" id="nonprint">マイ機器名：{{ Name }}</v-card-title>
      <v-row dense id="nonprint">
        <v-col cols="12" lg="12" dense>
          <v-card flat outlined class="pa-3 mb-5">
            <div class="subtitle-2 mb-2">
              <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
              <span class="primary--text">QRコードについて</span>
            </div>
            <p class="caption">
              QRコードをスマートフォン等から読み取っていただくことで、サンプル登録画面に直接アクセスできます。<br>
              印刷してマイ機器に貼り付けなど、サンプル登録（採油）する際にアクセスしやすい場所で保管してください。<br>
              <br>
              貼り付け場所／保管場所によっては引火の危険性や、水濡れや油汚れなどによる読み取り不正の可能性があります。<br>
              貼り付けてご使用いただく際は貼り付け場所や保管方法にご注意ください。
              </p>
          </v-card>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" dense>
          <v-card outlined id="sample-card">
            <span class="body-1 ml-2 font-weight-bold">ジャパン・アナリスト分析･診断サービス</span><br>
            <span class="body-1 ml-2 font-weight-bold">サンプル登録QRコード</span>（{{Type}}）<br>
            <br>
            <span class="body-5 ml-2">マイ機器名</span><br>
            <span class="body-1 ml-4 font-weight-bold">{{ Name }}</span><br>
            <template v-if="Type != '機体'">
              <br>
              <span class="body-5 ml-2">マイ機器ＩＤ</span><br>
              <span class="body-1 ml-4 font-weight-bold">{{ CustomerMachineID }}</span>
            </template>
            <div class="ml-2">
              <vue-qrcode v-model="embedURL" :width=250></vue-qrcode>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-overlay absolute :value="overlayStepper1" opacity="0.8" color="white">
        <v-progress-circular indeterminate size="64" color="amber"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
  </v-container>
</template>

<script>
// import { API, graphqlOperation} from "aws-amplify"
// import { getApplication } from '../graphql/queries'
import VueQrcode from 'vue-qrcode'

export default {
  components: {
    VueQrcode,
  },
  head: {
    title: { inner: 'マイ機器QRコード'},
  },
  data: () => ({
    // applicationid: "",
    // application: {},
    samplingurl: "initialDummy",
    myaircrafturl: "initialDummy",
    embedURL: "initialDummy",
    overlayStepper1: true,
    machineid: '',
    Name: '',
    CustomerMachineID: '',
    Type: '',
  }),
  mounted: async function () {
    // console.log('machine id: ', this.$route.query.id)
    this.machineid = this.$route.query.id
    this.Name = this.$route.query.name
    this.CustomerMachineID = this.$route.query.machineid
    this.Type = this.$route.query.type
    this.samplingurl = process.env.VUE_APP_MACHINE_QRCODE + this.machineid
    this.myaircrafturl = process.env.VUE_APP_AIRCRAFT_QRCODE + this.machineid
    console.log('samplingurl',this.samplingurl)
    console.log('myaircrafturl',this.myaircrafturl)

    if(this.Type == "機体") {
      this.embedURL = this.myaircrafturl
    }else {
      this.embedURL = this.samplingurl
    }
    
    console.log('embedURL',this.embedURL)
    console.log('env',process.env)


    // console.log('aa application id: ', this.$route.query.id)
    // this.applicationid = this.$route.query.id
    // let application = await API.graphql(graphqlOperation(getApplication, {id: this.applicationid}))
    // console.log('dataget_success', application)
    // this.application = application.data.getApplication
    // console.log('application', this.application)
    this.overlayStepper1 = false    
  },
  methods: {
    barcodePrint: async function () {
      window.print()
    },
  },
  filters: {
    truncate: function(value) {
      var length = 14
      if (value.length <= length ) {
        return value
      }
      return value.substring(0, length) + '..'
    }
  }
}
</script>
<style lang="scss" scoped>
@media print {
  #nonprint { 
    display: none;
  }
  #printable-caption {
    font-size : 8px !important;
    margin: 0px !important;
  }
  #printable-title {
    font-size : 8px;
    padding: 0px !important;
  }
  #card-title {
    font-size : 8px !important;
  }
  #card-body {
    font-size : 8px !important;
  }
  #sample-title  {
    font-size : 8px !important;
    padding: 0px !important;
    margin-left: 2px !important;
  }
  #sample-body  {
    font-size : 8px !important;    
  }
  #sample-card {
    padding: 0px !important;
    margin: 0px  !important;
    border: solid 1px !important;
  }
  #sample-hidden {
    display: none;
  }
  #bottle-caption {
    font-size : 8px !important;
  }
  .v-toolbar {
    display: none;
  }
  .v-content {
    padding: 0px !important;
  }
  .container {
    padding: 0px !important;
    margin: 0px  !important;
  }
  .v-sheet {
    padding: 0px !important;
  }
  .v-card {
    box-shadow: none !important ;
  }
  .pagebreak {
    page-break-before: always !important;
  }
}
</style>